export default __webpack_public_path__ + "static/media/include_11@3x.3950cc1d.jpg";